import { IS_MEZO_MAINNET } from "./network"

const isFeatureEnabled = (flag?: string) => !!flag && flag === "true"

export const ENABLE_LEDGER_WALLET_PLACEHOLDER = isFeatureEnabled(
  process.env.ENABLE_LEDGER_WALLET_PLACEHOLDER,
)

export const ENABLE_SWAPS = isFeatureEnabled(process.env.ENABLE_SWAPS)

export const ENABLE_GOVERNANCE_PAGE = isFeatureEnabled(
  process.env.ENABLE_GOVERNANCE_PAGE,
)

export const ENABLE_DISCORD_SIGNUP = isFeatureEnabled(
  process.env.ENABLE_DISCORD_SIGNUP,
)

export const ENABLE_BORROW_LIQUIDATIONS_PRICES = isFeatureEnabled(
  process.env.ENABLE_BORROW_LIQUIDATIONS_PRICES,
)

export const ENABLE_BORROW_PRICE_CHANGES = isFeatureEnabled(
  process.env.ENABLE_BORROW_PRICE_CHANGES,
)

export const ENABLE_DEFAULT_ANALYTICS_CONSENT = isFeatureEnabled(
  process.env.ENABLE_DEFAULT_ANALYTICS_CONSENT,
)

export const ENABLE_STAKE_WITHDRAWAL = isFeatureEnabled(
  process.env.ENABLE_STAKE_WITHDRAWAL,
)

export const ENABLE_STAKE_MANAGEMENT = isFeatureEnabled(
  process.env.ENABLE_STAKE_MANAGEMENT,
)

export const ENABLE_DISCORD_ONBOARDING = isFeatureEnabled(
  process.env.ENABLE_DISCORD_ONBOARDING,
)

export const ENABLE_VAULT_PAGE =
  isFeatureEnabled(process.env.ENABLE_VAULT_PAGE) && IS_MEZO_MAINNET

export const ENABLE_MATS_REWARDS_FOR_SIGNUP = isFeatureEnabled(
  process.env.ENABLE_MATS_REWARDS_FOR_SIGNUP,
)
export const ENABLE_MATS_REWARDS_FOR_BORROW = isFeatureEnabled(
  process.env.ENABLE_MATS_REWARDS_FOR_BORROW,
)

export const ENABLE_LANDING_PAGES = isFeatureEnabled(
  process.env.ENABLE_LANDING_PAGES,
)

export const QA_MODE = isFeatureEnabled(process.env.QA_MODE)
